
import { createContext } from 'react';
import { NotifyMethod } from '../../components/Notifier';

export default createContext<NotifyMethod>(()=>null);
